export default __webpack_public_path__ + "static/media/Success.8929a6c5.jpg";